import { Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/system";

function Cpc() {
  return (
    <Box className="KeywordDataWrapper">
      {Array.from({ length: 7 }).map((_, index) => (
        <Box className="BodyData">
          <Typography component="span" className="keywords">
            <Skeleton variant="text" width={150} />
          </Typography>
          <Typography component="span" className="SearchVolume">
            <Skeleton variant="text" width={100} />
          </Typography>
          <Typography component="span" className="Difficulty">
            <Skeleton variant="text" width={100} />
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default Cpc;
